import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BASE_URL from "../../../../config/config";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { handleChange, handleSubmit } from "../../../SuperAdmin/Controller/Client/UpdateClientPrefix";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import Loader from "../Loader";
import DateFormatService from "../../controller/DateFormatController/DateFormatController";
import HelpSite from "../../../Common/HelpLink";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import CountryService from "../../../Setup/controller/CountryController/CountryController";
function CompanySetup() {
  const { t } = useTranslation(); // Hook to access translations
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const { theme } = useContext(ThemeContext);
  const [DateFormatList, setDateFormatList] = useState([]);
  const [DatabaseBackup, setDatabaseBackup] = useState('0');
  const HelpLink = localStorage.getItem('HelpLink');
  const [checkboxState, setCheckboxState] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [CountryList, setCountries] = useState([]);
  useEffect(() => {
    fetchDateFormat();
    fetchDownloadBackup();
    fetchCountries();
    async function fetchCompanySetup() {
      try {
        const redirectCallback = () => {
          navigate('/'); // Redirect to the login page
        };
        const ClientID = localStorage.getItem('CompanyID');
        const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
        setFormData(companySetup[0] || {}); // Initialize formData with the fetched data
      } catch (error) {
        console.error('Error fetching Roles:', error);
      }
    }
    fetchCompanySetup();
  }, [navigate]);
  const fetchDateFormat = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const dateFormat = await DateFormatService.GetAll(redirectCallback);
      setDateFormatList(dateFormat);
      const defaultDateTime = dateFormat.find(format => format.IsActive === 1);
      if (defaultDateTime) {
        setFormData(prevFormData => ({
          ...prevFormData,
          DateFormatID: defaultDateTime.ID, // Assuming IssuePriorityID is the field name
        }));
      }

    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
  };
  const fetchCountries = async () => {
    try {
      const listOfCountries = await CountryService.GetAllCountries();
      setCountries(listOfCountries);
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };
  const fetchDownloadBackup = async () => {
    try {
      const dbBackup = await CompanySetupController.DownloadDatabaseBackup();
      setDatabaseBackup(dbBackup?.[0]?.UserID ?? 0);

    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
  };

  const handleFieldChange = (event) => {
    handleChange(event, formData, setFormData);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const redirectUserList = () => {
        navigate('/AdministrationSetting?saved=true'); // Redirect to the user list page
      };
      await handleSubmit(formData, setFormData, setErrors, redirectCallback, redirectUserList);
      const updatedCompanySetup = await CompanySetupController.GetCompanyByID(redirectCallback, formData.CoSetupID);
      setFormData(updatedCompanySetup[0] || {});
      window.scrollTo(0, 0);
    } catch (error) {
      setErrors({ submit: 'Submission failed. Please try again.' });
      console.error('Error submitting form:', error);
    }
  };
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState({ ...checkboxState, [name]: checked });

    // Update the formData state
    setFormData({
      ...formData,
      [name]: checked, // Store true/false for checkbox
    });
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFormData(prevState => ({
      ...prevState,
      File: file,
      Path: file ? file.name : ''
    }));
  };
  const handleRestoreFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const handleDownloadBackup = async () => {
    try {
      setLoading(true);
      const response = await CompanySetupController.DownloadBackup();
      if (response.data) {
        Swal.fire(
          'Success!',
          'Backup request submitted. Please check status later.',
          'success'
        );
      }

    } catch (err) {
      console.error('Error downloading backup:', err);
      //alert('Failed to download backup');
    }
    finally {
      setLoading(false);
    }
  };
  const handleRestoreBackup = async () => {
    if (!selectedFile) {
      alert("Please select a backup file (.sql)");
      return;
    }

    try {
      setLoading(true);
      const postData = await CompanySetupController.RestoreDatabaseBackup(selectedFile);
      if (postData.message === "Data Saved Successfully") {
        Swal.fire(
          'Success!',
          'Database restored successfully.',
          'success'
        );
      }

    } catch (err) {
      console.error('Error restoring backup:', err);
      Swal.fire('Error', 'Failed to restore backup.', 'error');
    } finally {
      setLoading(false);
    }
  };


  const handleDownload = async () => {
    try {
      setLoading(true);

      const dbBackup = await CompanySetupController.DownloadDatabaseBackup();
      if (dbBackup.length > 0) {
        const filePath = dbBackup[0].FilePath;
        const fileName = filePath.split('/').pop();
        const downloadUrl = `${BASE_URL}/uploads/backups/${fileName}`;
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName); // optional
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    } catch (err) {
      console.error('Error downloading backup:', err);
      //alert('Failed to download backup');
    }
    finally {
      setLoading(false);
    }
  };
  return (
    <div>
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <form onSubmit={handleFormSubmit}>
        <div className="row mb-3">
          <div className="col-sm-12" style={{ "textAlign": "right" }}>
            <HelpSite FormName="Company Setup" Module="26" />
          </div>
        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label htmlFor="CompanyName" className="col-sm-2 col-form-label">Company Name</label>
          <div className="col-sm-4">
            <input type="text" className="form-control" name="CompanyName" value={formData.CompanyName || ''} onChange={handleFieldChange} />
            {errors.CompanyName && <div style={{ color: 'red' }}>{errors.CompanyName}</div>}
          </div>
          <label for="inputText" className="col-sm-2 col-form-label">Address 1</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Address1" value={formData.Address1} onChange={handleFieldChange} />
            {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
          </div>
        </div>
        {/* Repeat similar structure for other fields */}
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">Town</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Town" value={formData.Town} onChange={handleFieldChange} />
            {errors.Town && <div style={{ color: 'red' }}>{errors.Town}</div>}


          </div>
          <label for="inputText" className="col-sm-2 col-form-label"></label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Address2" value={formData.Address2} onChange={handleFieldChange} />
            {errors.Address2 && <div style={{ color: 'red' }}>{errors.Address2}</div>}
          </div>
        </div>

        <div className="row mb-3" style={{ "marginLeft": "0px" }}>

          <label for="inputText" className="col-sm-2 col-form-label">Contact</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Contact" value={formData.Contact} onChange={handleFieldChange} />
            {errors.Contact && <div style={{ color: 'red' }}>{errors.Contact}</div>}
          </div>
          <label for="inputText" className="col-sm-2 col-form-label">Telephone</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Telephone" value={formData.Telephone} onChange={handleFieldChange} />
            {errors.Telephone && <div style={{ color: 'red' }}>{errors.Telephone}</div>}
          </div>
        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">County</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="County" value={formData.County} onChange={handleFieldChange} />
            {errors.County && <div style={{ color: 'red' }}>{errors.County}</div>}


          </div>
          <label for="inputText" className="col-sm-2 col-form-label">Fax</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Fax" value={formData.Fax} onChange={handleFieldChange} />
            {errors.Fax && <div style={{ color: 'red' }}>{errors.Fax}</div>}
          </div>
        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">Post Code</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Postcode" value={formData.Postcode} onChange={handleFieldChange} />
            {errors.Postcode && <div style={{ color: 'red' }}>{errors.Postcode}</div>}
          </div>
          <label for="inputText" className="col-sm-2 col-form-label">Email</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Email" value={formData.Email} onChange={handleFieldChange} />
            {errors.Email && <div style={{ color: 'red' }}>{errors.Email}</div>}
          </div>

        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">Country</label>
          <div className="col-sm-4">
            <select name="Country" className='form-control' value={formData.Country} onChange={handleFieldChange}>
              <option value="0">Select Country</option>
              {CountryList.map((country) => (
                <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                  {country.vc_CountryName}
                </option>
              ))}
            </select>



            {errors.Country && <div style={{ color: 'red' }}>{errors.Country}</div>}


          </div>
          <label for="inputText" className="col-sm-2 col-form-label">Date Format</label>
          <div className="col-sm-4">
            <select name="DateFormatID" className='form-control' value={formData.DateFormatID}
              onChange={handleFieldChange}
            >
              <option value="0">Select Date Format</option>
              {DateFormatList.map((format, index) => (
                <option key={format.ID} value={format.ID}>
                  {format.DateFormat}
                </option>
              ))}
            </select>
            {errors.DateFormatID && <div style={{ color: 'red' }}>{errors.DateFormatID}</div>}
          </div>

        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">VAT Registration</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="VATReg" value={formData.VATReg} onChange={handleFieldChange} />
            {errors.VATReg && <div style={{ color: 'red' }}>{errors.VATReg}</div>}
          </div>
          <label for="inputText" className="col-sm-2 col-form-label">WebSite</label>
          <div className="col-sm-4">
            <input type="text" className='form-control' name="Website" value={formData.Website} onChange={handleFieldChange} />
            {errors.Website && <div style={{ color: 'red' }}>{errors.Website}</div>}
          </div>
        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">Allow SAM to Login</label>
          <div className="col-sm-4">
            <input type="checkbox" name="IsAdminAllowed" className="form-check-input" onChange={event => handleCheckboxChange(event)} checked={formData.IsAdminAllowed == '1'} />
          </div>
          <label htmlFor="Path" className="col-sm-2 col-form-label">Attach Logo:<span style={{ "color": "red" }}>*</span></label>
          <div className="col-sm-3">
            <input type="file" className="form-control file-control" name="File" onChange={handleFileChange} />
            {errors.Path && <div style={{ color: 'red' }}>{errors.Path}</div>}
          </div>
          <div className="col-sm-1">
            {formData.LogoID > 0 &&
              <a href={`${BASE_URL}/uploads/${formData.CoSetupID}/Admin/CompanySetup/${formData.FileName}`} target='_blank' >
                <img style={{ "width": "30px", "height": "30px" }} src={`${BASE_URL}/uploads/${formData.CoSetupID}/Admin/CompanySetup/${formData.FileName}`}></img>
              </a>
            }

          </div>
        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">Subscription Days Left</label>
          <div className="col-sm-4">{formData.TimeLeft}</div>
          <label for="inputText" className="col-sm-2 col-form-label">Version Deployed</label>
          <div className="col-sm-4">d228c8f</div>

        </div>



        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <div className="col-sm-4"></div>
          <div className="col-sm-8" >
            <button type="submit" style={{ "float": "right", "marginLeft": "10px" }} className="btn btn-primary">
              <i className="icofont-save" aria-hidden="true"> Save

              </i>
            </button>


          </div>

        </div>

      </form >
    </div>
  );
}

export default CompanySetup;
